/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// Low Stock Warning für Variant Picker
console.log('Custom.js loaded - Starting Low Stock Warning script');

document.addEventListener('DOMContentLoaded', function() {
  console.log('DOMContentLoaded fired');
  const productVariants = document.querySelectorAll('product-variants');
  console.log('Found product-variants elements:', productVariants.length);
  
  productVariants.forEach(function(productVariant, index) {
    console.log(`Processing product-variant ${index + 1}`);
    const formId = productVariant.getAttribute('form-id');
    console.log('Form ID:', formId);
    const form = document.getElementById(formId);
    
    if (!form) {
      console.log('Form not found for ID:', formId);
      return;
    }
    console.log('Form found:', form);
    
    const lowStockDataScript = productVariant.querySelector('script[data-low-stock-data]');
    if (!lowStockDataScript) {
      console.log('Low stock data script not found in product-variant');
      return;
    }
    console.log('Low stock data script found');
    
    const lowStockData = JSON.parse(lowStockDataScript.textContent);
    const sizeOptionIndex = lowStockData.sizeOptionIndex;
    const threshold = lowStockData.threshold;
    
    // Debug: Ausgabe der Low Stock Daten
    console.log('Low Stock Data:', lowStockData);
    console.log('Threshold:', threshold);
    console.log('Size Option Index:', sizeOptionIndex);
    console.log('Variants:', lowStockData.variants);
    
    // Finde das product-form__option-info Element für Size
    const optionSelectors = productVariant.querySelectorAll('.product-form__option-selector');
    console.log('Found option selectors:', optionSelectors.length);
    let sizeOptionInfo = null;
    
    optionSelectors.forEach(function(selector, idx) {
      const optionName = selector.querySelector('.product-form__option-name');
      if (optionName) {
        const optionNameText = optionName.textContent.toLowerCase().replace(':', '').trim();
        console.log(`Option ${idx + 1} name:`, optionNameText);
        if (optionNameText === 'size' || optionNameText === 'größe') {
          sizeOptionInfo = selector.querySelector('.product-form__option-info');
          console.log('Size option info found:', sizeOptionInfo);
        }
      }
    });
    
    if (!sizeOptionInfo) {
      console.log('Size option info not found');
      return;
    }
    
    // Entferne vorhandene Low Stock Meldung
    const existingLowStock = sizeOptionInfo.querySelector('.product-form__option-low-stock');
    if (existingLowStock) {
      existingLowStock.remove();
    }
    
    // Funktion zum Aktualisieren der Low Stock Meldung
    function updateLowStockWarning(variant) {
      // Entferne vorhandene Meldung
      const existingLowStock = sizeOptionInfo.querySelector('.product-form__option-low-stock');
      if (existingLowStock) {
        existingLowStock.remove();
      }
      
      // Debug: Variant Information
      console.log('Update Low Stock Warning - Variant:', variant);
      
      if (!variant || !lowStockData.variants[variant.id]) {
        console.log('No variant or variant data not found for ID:', variant?.id);
        return;
      }
      
      const variantData = lowStockData.variants[variant.id];
      
      // Debug: Variant Data Details
      console.log('Variant Data:', {
        id: variant.id,
        size: variantData.size,
        inventoryQuantity: variantData.inventoryQuantity,
        inventoryManagement: variantData.inventoryManagement,
        inventoryPolicy: variantData.inventoryPolicy,
        lowStock: variantData.lowStock,
        threshold: threshold
      });
      
      // Prüfe die Low Stock Bedingung direkt
      // Meldung anzeigen wenn: inventory_quantity > 0 UND inventory_quantity < threshold
      // UND showLowStock aktiviert ist
      const shouldShow = lowStockData.showLowStock !== false &&
                        variantData.inventoryManagement && 
                        variantData.inventoryPolicy === 'deny' && 
                        variantData.inventoryQuantity > 0 && 
                        variantData.inventoryQuantity < threshold;
      
      console.log('Low Stock Check:', {
        variantId: variant.id,
        inventoryQuantity: variantData.inventoryQuantity,
        threshold: threshold,
        showLowStock: lowStockData.showLowStock,
        inventoryManagement: variantData.inventoryManagement,
        inventoryPolicy: variantData.inventoryPolicy,
        condition1: lowStockData.showLowStock !== false,
        condition2: variantData.inventoryManagement,
        condition3: variantData.inventoryPolicy === 'deny',
        condition4: variantData.inventoryQuantity > 0,
        condition5: variantData.inventoryQuantity < threshold,
        shouldShow: shouldShow,
        lowStockFlag: variantData.lowStock
      });
      
      if (shouldShow && variantData.size) {
        const lowStockSpan = document.createElement('span');
        lowStockSpan.className = 'product-form__option-low-stock';
        lowStockSpan.setAttribute('data-variant-id', variant.id);
        
        // Übersetzungstext aus Liquid
        const count = variantData.inventoryQuantity;
        const translation = lowStockData.translation;
        let text;
        if (count === 1) {
          text = translation.lowStockOne.replace('{{count}}', count).replace('{{ count }}', count);
        } else {
          text = translation.lowStockOther.replace('{{count}}', count).replace('{{ count }}', count);
        }
        lowStockSpan.textContent = text;
        
        // Füge nach dem option-value ein
        const optionValue = sizeOptionInfo.querySelector('.product-form__option-value');
        if (optionValue) {
          optionValue.insertAdjacentElement('afterend', lowStockSpan);
        } else {
          sizeOptionInfo.appendChild(lowStockSpan);
        }
      }
    }
    
    // Initiale Anzeige
    form.addEventListener('variant:changed', function(event) {
      updateLowStockWarning(event.detail.variant);
    });
    
    // Initiale Variante prüfen
    const initialVariantId = form.querySelector('[name="id"]')?.value;
    if (initialVariantId && lowStockData.variants[initialVariantId]) {
      const initialVariant = { id: parseInt(initialVariantId) };
      updateLowStockWarning(initialVariant);
    }
  });
});

/**
 * ------------------------------------------------------------------------------------------------------------
 * ICON LINKS SCROLL INDICATOR
 * ------------------------------------------------------------------------------------------------------------
 * Hide the scroll indicator when the user has scrolled to the end of the icon links scroller.
 */
document.addEventListener('DOMContentLoaded', function() {
  const scrollers = document.querySelectorAll('.icon-links__scroller');
  
  scrollers.forEach(function(scroller) {
    const indicator = scroller.parentElement.querySelector('.icon-links__scroll-indicator');
    if (!indicator) return;
    
    function updateIndicator() {
      const scrollLeft = scroller.scrollLeft;
      const scrollWidth = scroller.scrollWidth;
      const clientWidth = scroller.clientWidth;
      const scrollEnd = scrollWidth - clientWidth;
      
      // Hide indicator when scrolled near the end (within 10px)
      if (scrollLeft >= scrollEnd - 10) {
        indicator.style.opacity = '0';
      } else {
        indicator.style.opacity = '1';
      }
    }
    
    scroller.addEventListener('scroll', updateIndicator);
    // Check initial state
    updateIndicator();
  });
});